


// import React, { useState } from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
// import Login from "./components/Login.js";
// import Verification from "./components/verification.js";
// import JobsHistory from "./layouts/JobsHistory.js";
// import AssignJob from "./layouts/AssignJob.js";
// import Sidebar from "../src/components/navbar/Slidebar.js";
// import TodayAttendance from "./layouts/TodayAttendance.js";
// import AssignOT from "./layouts/AssignOT.js";
// import OTDetails from "./layouts/OTDetails.js";
// import HolidayOT from "./layouts/HolidayOT";
// import QRScanner from "./layouts/QRScanner.js";
// import { IconButton, AppBar, Toolbar, Box } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import JobsHistoryAll from "./layouts/JobHistoryAll.js";
// import ProtectedRoute from "./components/Protectedroute.js";


// function App() {
//   const [drawerOpen, setDrawerOpen] = useState(false);

//   const sidebarPages = [
//     "/home",
//     "/todayAttendance",
//     "/jobHistory",
//     "/jobHistoryAll",
//     "/assignJob",
//     "/assignOT",
//     "/otDetails",
//     "/holidayOT"
//   ];

//   const location = useLocation();

//   const shouldRenderSidebar = sidebarPages.includes(location.pathname);

//   return (
//     <>
//       {/* Header with the hamburger menu icon */}
//       <AppBar
//         position="fixed"
//         sx={{ backgroundColor: "transparent", boxShadow: "none" }}
//       >
//         <Toolbar>
//           {shouldRenderSidebar && ( // Only render the menu icon if the sidebar should be visible
//             <IconButton
//               edge="start"
//               color="inherit"
//               onClick={() => setDrawerOpen(!drawerOpen)}
//               sx={{ mr: 2 }}
//             >
//               <MenuIcon />
//             </IconButton>
//           )}
//         </Toolbar>
//       </AppBar>

//       {/* Render Sidebar only on specified routes */}
//       {shouldRenderSidebar && (
//         <Sidebar open={drawerOpen} toggleDrawer={() => setDrawerOpen(!drawerOpen)} />
//       )}

//       <Box
//         sx={{
//           display: "flex",
//           marginTop: "64px",
//         }}
//       >
//         <Routes>
//           <Route path="/" element={<Login />} />
//           <Route path="/verify" element={<Verification />} />
//           <Route path="/home" element={<ProtectedRoute> <QRScanner /> </ProtectedRoute>} />          
//           <Route path="/jobHistory" element={<ProtectedRoute> <JobsHistory /> </ProtectedRoute>} />
//           <Route path="/jobHistoryAll" element={<ProtectedRoute> <JobsHistoryAll /> </ProtectedRoute>} />
//           <Route path="/assignJob" element={<ProtectedRoute> <AssignJob /> </ProtectedRoute>} />
//           <Route path="/todayAttendance" element={<ProtectedRoute> <TodayAttendance /> </ProtectedRoute>} />
//           <Route path="/assignOT" element={<ProtectedRoute> <AssignOT /> </ProtectedRoute>} />       
//           <Route path="/otDetails" element={<ProtectedRoute> <OTDetails /> </ProtectedRoute>} /> 
//           <Route path="/holidayOT" element={<ProtectedRoute> <HolidayOT /> </ProtectedRoute>} />     
               
//           <Route path="*" element={<Navigate to="/" />} />
//         </Routes>
//       </Box>
//     </>
//   );
// }

// export default function Root() {
//   return (
//     <Router>
//       <App />
//     </Router>
//   );
// }


// import React, { useState, useEffect } from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { restoreSession } from "./actions/authActions";
// import Login from "./components/Login.js";
// import Verification from "./components/verification.js";
// import JobsHistory from "./layouts/JobsHistory.js";
// import AssignJob from "./layouts/AssignJob.js";
// import Sidebar from "../src/components/navbar/Slidebar.js";
// import TodayAttendance from "./layouts/TodayAttendance.js";
// import AssignOT from "./layouts/AssignOT.js";
// import OTDetails from "./layouts/OTDetails.js";
// import HolidayOT from "./layouts/HolidayOT";
// import QRScanner from "./layouts/QRScanner.js";
// import { IconButton, AppBar, Toolbar, Box } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import JobsHistoryAll from "./layouts/JobHistoryAll.js";
// import ProtectedRoute from "./components/ProtectedRoute.js";
// //dulitha
// import OTTableViews from "./layouts/OTViewTables.js"
// import SupervisorWiseOT from "./components/tables/SupervisorWiseOT.js"
// import NonAllocatedEmp from "./components/tables/NonAllocatedEmp.js"


// function App() {
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const dispatch = useDispatch();

//   // Restore session on app initialization
//   useEffect(() => {
//     dispatch(restoreSession());
//   }, [dispatch]);

//   const sidebarPages = [
//     "/home",
//     "/todayAttendance",
//     "/jobHistory",
//     "/jobHistoryAll",
//     "/assignJob",
//     "/assignOT",
//     "/otDetails",
//     "/holidayOT",
//     "/overTimeView",//dulitha
//   ];

//   const location = useLocation();
//   const shouldRenderSidebar = sidebarPages.includes(location.pathname);

//   return (
//     <>
//       {/* Header with the hamburger menu icon */}
//       <AppBar
//         position="fixed"
//         sx={{ backgroundColor: "transparent", boxShadow: "none" }}
//       >
//         <Toolbar>
//           {shouldRenderSidebar && (
//             <IconButton
//               edge="start"
//               color="inherit"
//               onClick={() => setDrawerOpen(!drawerOpen)}
//               sx={{ mr: 2 }}
//             >
//               <MenuIcon />
//             </IconButton>
//           )}
//         </Toolbar>
//       </AppBar>

//       {/* Render Sidebar only on specified routes */}
//       {shouldRenderSidebar && (
//         <Sidebar open={drawerOpen} toggleDrawer={() => setDrawerOpen(!drawerOpen)} />
//       )}

//       <Box
//         sx={{
//           display: "flex",
//           marginTop: "64px",
//         }}
        
//       >
//         <Routes>
//           <Route path="/" element={ <Login /> } />
//           <Route path="/verify" element={<Verification />} />
//           <Route path="/home" element={<ProtectedRoute> <QRScanner /> </ProtectedRoute>} />          
//           <Route path="/jobHistory" element={<ProtectedRoute> <JobsHistory /> </ProtectedRoute>} />
//           <Route path="/jobHistoryAll" element={<ProtectedRoute> <JobsHistoryAll /> </ProtectedRoute>} />
//           <Route path="/assignJob" element={<ProtectedRoute> <AssignJob /> </ProtectedRoute>} />
//           <Route path="/todayAttendance" element={<ProtectedRoute> <TodayAttendance /> </ProtectedRoute>} />
//           <Route path="/assignOT" element={<ProtectedRoute> <AssignOT /> </ProtectedRoute>} />       
//           <Route path="/otDetails" element={<ProtectedRoute> <OTDetails /> </ProtectedRoute>} /> 
//           <Route path="/holidayOT" element={<ProtectedRoute> <HolidayOT /> </ProtectedRoute>} /> 
//           <Route path="/overTimeView" element={<ProtectedRoute> <OTTableViews /> </ProtectedRoute>} />  
//           <Route path="/supervisorWiseOT" element={<ProtectedRoute> <SupervisorWiseOT /> </ProtectedRoute>} />  
//           <Route path="/nonAllocatedEmp" element={<ProtectedRoute> <NonAllocatedEmp /> </ProtectedRoute>} />
               
//           <Route path="*" element={<Navigate to="/" />} />
//         </Routes>
//       </Box>
//     </>
//   );
// }

// export default function Root() {
//   return (
//     <Router>
//       <App />
//     </Router>
//   );
// }












import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { restoreSession } from "./actions/authActions";
import Login from "./components/Login.js";
import Registration from "./components/Registration.js";
import EmployeeRegister from "./layouts/EmployeeRegister.js"; 
import Verification from "./components/verification.js";
import LookupManagement from "./layouts/LookupManagement.js";
import LeaveDashboard from "./layouts/leave/LeaveDashboard.js";
import HolidayCalendar from "./layouts/leave/HolidayCalendar.js";
import LeaveConfiguration from "./layouts/leave/LeaveConfiguration.js";
import LeaveAdjustments from "./layouts/leave/LeaveAdjustments.js";
import LeaveHistory from "./layouts/leave/LeaveHistory.js";
import LeaveApplication from "./layouts/leave/LeaveApplication.js";
import JobsHistory from "./layouts/JobsHistory.js";
import AssignJob from "./layouts/AssignJob.js";
import Sidebar from "../src/components/navbar/Slidebar.js";
import TodayAttendance from "./layouts/TodayAttendance.js";
import AssignOT from "./layouts/AssignOT.js";
import OTDetails from "./layouts/OTDetails.js";
import HolidayOT from "./layouts/HolidayOT";
import QRScanner from "./layouts/QRScanner.js";
import { IconButton, AppBar, Toolbar, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import JobsHistoryAll from "./layouts/JobHistoryAll.js";
import ProtectedRoute from "./components/ProtectedRoute.js";
import OTTableViews from "./layouts/OTViewTables.js"
import SupervisorWiseOT from "./components/tables/SupervisorWiseOT.js"
import NonAllocatedEmp from "./components/tables/NonAllocatedEmp.js"
import UserProfile from "./layouts/UserProfile.js";
import ShiftExchange from "./layouts/ShiftExchange.js";
import RosterScheduler from "./layouts/RosterScheduler.js";
// Remove or comment out this line since we don't have RosterManagement component yet
import RosterManagement from "./layouts/RosterManagement.js"; 

function App() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(restoreSession());
  }, [dispatch]);

  const sidebarPages = [
    "/home",
    "/todayAttendance",
    "/jobHistory",
    "/jobHistoryAll",
    "/assignJob",
    "/assignOT",
    "/otDetails",
    "/holidayOT",
    "/overTimeView",
    "/userProfile",
    "/shiftExchange",
    "/rosterSchedule",
    "/rosterManagement",
    "/employeeRegister", 
    "/employeeRegister/lookups",
    "/leave/dashboard",
    // "/leave/holidays",
    "/leave/configuration",
    "/leave/adjustments",
    "/leave/history",
    "/leave/application",
  ];
  const location = useLocation();
  const shouldRenderSidebar = sidebarPages.includes(location.pathname);

  return (
    <>
      <AppBar
        position="fixed"
        sx={{ backgroundColor: "transparent", boxShadow: "none" }}
      >
        <Toolbar>
          {shouldRenderSidebar && (
            <IconButton
              edge="start"
              onClick={() => setDrawerOpen(!drawerOpen)}
              sx={{ mr: 2, color: "#0b1b2b" }}
            >
              <MenuIcon />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>

      {shouldRenderSidebar && (
        <Sidebar open={drawerOpen} toggleDrawer={() => setDrawerOpen(!drawerOpen)} />
      )}

      <Box
        sx={{
          display: "flex",
          marginTop: "64px",
        }}
      >
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Registration />} />
          <Route path="/verify" element={<Verification />} />
          {/* Admin bulk employee registration page */}
          <Route path="/employeeRegister" element={<ProtectedRoute><EmployeeRegister /></ProtectedRoute>} />
          <Route path="/employeeRegister/lookups" element={<ProtectedRoute><LookupManagement /></ProtectedRoute>} />
          <Route path="/leave/dashboard" element={<ProtectedRoute><LeaveDashboard /></ProtectedRoute>} />
          <Route path="/leave/holidays" element={<ProtectedRoute><HolidayCalendar /></ProtectedRoute>} />
          <Route path="/leave/configuration" element={<ProtectedRoute><LeaveConfiguration /></ProtectedRoute>} />
          <Route path="/leave/adjustments" element={<ProtectedRoute><LeaveAdjustments /></ProtectedRoute>} />
          <Route path="/leave/history" element={<ProtectedRoute><LeaveHistory /></ProtectedRoute>} />
          <Route path="/leave/application" element={<ProtectedRoute><LeaveApplication /></ProtectedRoute>} />

          {/* Protected Routes */}
          <Route path="/home" element={<ProtectedRoute><OTTableViews /></ProtectedRoute>} />
          <Route path="/userProfile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
          <Route path="/shiftExchange" element={<ProtectedRoute><ShiftExchange /></ProtectedRoute>} />
          
          {/* Roster Management Routes - Use only RosterScheduler for now */}
          <Route path="/rosterSchedule" element={<ProtectedRoute><RosterScheduler /></ProtectedRoute>} />
          {/* Remove this route until you create the component */}
          <Route path="/rosterManagement" element={<ProtectedRoute><RosterManagement /></ProtectedRoute>} />
          
          {/* Job History Routes (commented out) */}
          {/* <Route path="/jobHistory" element={<ProtectedRoute><JobsHistory /></ProtectedRoute>} />
          <Route path="/jobHistoryAll" element={<ProtectedRoute><JobsHistoryAll /></ProtectedRoute>} />
          <Route path="/assignJob" element={<ProtectedRoute><AssignJob /></ProtectedRoute>} /> */}
          
          {/* Attendance Routes (commented out) */}
          {/* <Route path="/todayAttendance" element={<ProtectedRoute><TodayAttendance /></ProtectedRoute>} /> */}
          
          {/* Overtime Routes (commented out) */}
          {/* <Route path="/assignOT" element={<ProtectedRoute><AssignOT /></ProtectedRoute>} />       
          <Route path="/otDetails" element={<ProtectedRoute><OTDetails /></ProtectedRoute>} /> 
          <Route path="/holidayOT" element={<ProtectedRoute><HolidayOT /></ProtectedRoute>} /> */}
          
          {/* Management Info Routes (commented out) */}
          {/* <Route path="/overTimeView" element={<ProtectedRoute><OTTableViews /></ProtectedRoute>} />  
          <Route path="/supervisorWiseOT" element={<ProtectedRoute><SupervisorWiseOT /></ProtectedRoute>} />  
          <Route path="/nonAllocatedEmp" element={<ProtectedRoute><NonAllocatedEmp /></ProtectedRoute>} /> */}
          
          {/* QR Scanner Route (commented out) */}
          {/* <Route path="/qrScanner" element={<ProtectedRoute><QRScanner /></ProtectedRoute>} /> */}
          
          {/* Fallback Route */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Box>
    </>
  );
}

export default function Root() {
  return (
    <Router>
      <App />
    </Router>
  );
}

















// import React, { useState, useEffect } from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { restoreSession } from "./actions/authActions";
// import Login from "./components/Login.js";
// import Registration from "./components/Registration.js";
// import Verification from "./components/verification.js";
// import JobsHistory from "./layouts/JobsHistory.js";
// import AssignJob from "./layouts/AssignJob.js";
// import Sidebar from "../src/components/navbar/Slidebar.js";
// import TodayAttendance from "./layouts/TodayAttendance.js";
// import AssignOT from "./layouts/AssignOT.js";
// import OTDetails from "./layouts/OTDetails.js";
// import HolidayOT from "./layouts/HolidayOT";
// import QRScanner from "./layouts/QRScanner.js";
// import { IconButton, AppBar, Toolbar, Box } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import JobsHistoryAll from "./layouts/JobHistoryAll.js";
// import ProtectedRoute from "./components/ProtectedRoute.js";
// import OTTableViews from "./layouts/OTViewTables.js"
// import SupervisorWiseOT from "./components/tables/SupervisorWiseOT.js"
// import NonAllocatedEmp from "./components/tables/NonAllocatedEmp.js"
// import UserProfile from "./layouts/UserProfile.js";
// import ShiftExchange from "./layouts/ShiftExchange.js";
// import RosterScheduler from "./layouts/RosterScheduler.js";

// function App() {
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(restoreSession());
//   }, [dispatch]);

//  const sidebarPages = [
//   "/home",
//   "/todayAttendance",
//   "/jobHistory",
//   "/jobHistoryAll",
//   "/assignJob",
//   "/assignOT",
//   "/otDetails",
//   "/holidayOT",
//   "/overTimeView",
//   "/userProfile",
//   "/shiftExchange",
//   "/rosterSchedule",
//   "/rosterManagement" 
// ];

//   const location = useLocation();
//   const shouldRenderSidebar = sidebarPages.includes(location.pathname);

//   return (
//     <>
//       <AppBar
//         position="fixed"
//         sx={{ backgroundColor: "transparent", boxShadow: "none" }}
//       >
//         <Toolbar>
//           {shouldRenderSidebar && (
//             <IconButton
//               edge="start"
//               onClick={() => setDrawerOpen(!drawerOpen)}
//               sx={{ mr: 2, color: "#0b1b2b" }}
//             >
//               <MenuIcon />
//             </IconButton>
//           )}
//         </Toolbar>
//       </AppBar>

//       {shouldRenderSidebar && (
//         <Sidebar open={drawerOpen} toggleDrawer={() => setDrawerOpen(!drawerOpen)} />
//       )}

//       <Box
//         sx={{
//           display: "flex",
//           marginTop: "64px",
//         }}
//       >
//         <Routes>
//           <Route path="/" element={<Login />} />
//           <Route path="/register" element={<Registration />} />
//           <Route path="/verify" element={<Verification />} />
//           <Route path="/home" element={<ProtectedRoute><OTTableViews /></ProtectedRoute>} /> 
//           <Route path="/userProfile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />         
//           <Route path="/shiftExchange" element={<ProtectedRoute><ShiftExchange /></ProtectedRoute>} />
//           <Route path="/userProfile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
//           <Route path="/rosterSchedule" element={<ProtectedRoute><RosterScheduler /></ProtectedRoute>} /> 
//           <Route path="/rosterManagement" element={<ProtectedRoute><RosterManagement /></ProtectedRoute>} />        
//           {/* <Route path="/jobHistory" element={<ProtectedRoute><JobsHistory /></ProtectedRoute>} />
//           <Route path="/jobHistoryAll" element={<ProtectedRoute><JobsHistoryAll /></ProtectedRoute>} />
//           <Route path="/assignJob" element={<ProtectedRoute><AssignJob /></ProtectedRoute>} /> */}
//           {/* <Route path="/todayAttendance" element={<ProtectedRoute><TodayAttendance /></ProtectedRoute>} /> */}
//           {/* <Route path="/assignOT" element={<ProtectedRoute><AssignOT /></ProtectedRoute>} />       
//           <Route path="/otDetails" element={<ProtectedRoute><OTDetails /></ProtectedRoute>} /> 
//           <Route path="/holidayOT" element={<ProtectedRoute><HolidayOT /></ProtectedRoute>} />  */}
//           {/* <Route path="/overTimeView" element={<ProtectedRoute><OTTableViews /></ProtectedRoute>} />  
//           <Route path="/supervisorWiseOT" element={<ProtectedRoute><SupervisorWiseOT /></ProtectedRoute>} />  
//           <Route path="/nonAllocatedEmp" element={<ProtectedRoute><NonAllocatedEmp /></ProtectedRoute>} /> */}
//           <Route path="*" element={<Navigate to="/" />} />
//         </Routes>
//       </Box>
//     </>
//   );
// }

// export default function Root() {
//   return (
//     <Router>
//       <App />
//     </Router>
//   );
// }